<template>
  <a-card :bordered="false">
    <div class="table-page-search-wrapper">
      <a-form layout="inline">
        <a-row :gutter="48">
          <a-col :md="6" :sm="24">
            <a-form-item label="关键字">
              <a-input v-model="queryParam.keywords" clearable placeholder="请输入姓名或身份证号"/>
            </a-form-item>
          </a-col>
          <a-col :md="6" :sm="24">
            <a-form-item label="领取单位">
              <a-input v-model="queryParam.danwei" placeholder="搜索领取单位"/>
            </a-form-item>
          </a-col>


          <a-col :md="6" :sm="24">
            <a-form-item label="学段">
              <a-select v-model="queryParam.xueduan" placeholder="请选择"
                        allowClear>
                <a-select-option value="幼儿园">幼儿园</a-select-option>
                <a-select-option value="小学">小学</a-select-option>
                <a-select-option value="初中">初中</a-select-option>
                <a-select-option value="高中">高中</a-select-option>
                <a-select-option value="大学">大学</a-select-option>
              </a-select>
            </a-form-item>
          </a-col>
            <a-col :md="6" :sm="24">
              <a-form-item label="申报时间">
                <a-range-picker
                    v-model="time_range_moment"
                    style="width: 100%"
                    format="YYYY-MM-DD HH:mm:ss"
                    :showTime="{
                defaultValue: [moment('00:00:00', 'HH:mm:ss'), moment('23:59:59', 'HH:mm:ss')]
                }"
                />
              </a-form-item>
            </a-col>
          <a-col :md="6" :sm="24">
            <a-form-item label="赛季赛区">
              <a-cascader :show-search="{ sjsqFilter }" :options="sjsqOptions"
                          :fieldNames="{ label: 'name', value: 'id', children: 'children' }" placeholder="请选择赛区"
                          v-model="queryParam.sjsq" changeOnSelect/>
            </a-form-item>
          </a-col>


          <template v-if="advanced">
            <a-col :md="6" :sm="24">
              <a-form-item label="多身份证查询">
                <a-textarea
                  v-model="queryParam.nums"
                  placeholder="请输入身份证多条换行"
                />
              </a-form-item>
            </a-col>
            <a-col :md="6" :sm="24">
              <a-form-item label="是否百佳">
                <a-select
                  v-model="queryParam.is_baijia"
                  placeholder="请选择"
                  allowClear
                > 
                  <a-select-option value="1">是</a-select-option>
                  <a-select-option value="2">否</a-select-option> 
                </a-select>
              </a-form-item>
            </a-col>

 

          </template>
          <a-col :md="!advanced && 6 || 24" :sm="24">
            <span class="table-page-search-submitButtons"
                  :style="advanced && { float: 'right', overflow: 'hidden' } || {} ">
              <a-button type="primary" @click="onSearch">查询</a-button>
              <a-button style="margin-left: 8px" @click="() => queryParam = {}">重置</a-button>
              <a @click="toggleAdvanced" style="margin-left: 8px" >
                {{ advanced ? '收起' : '展开' }}
                <a-icon :type="advanced ? 'up' : 'down'"/>
              </a>
            </span>
          </a-col>
        </a-row>
      </a-form>
    </div>


    <div class="table-operator">
      <a-button @click="download2(1)" style="margin-left: 8px">
        下载信息表
        <a-icon type="download" />
      </a-button>
      <a-dropdown v-if="selectedRowKeys.length > 0">
        <a-menu slot="overlay">
          <!--          <a-menu-item key="1"><a-icon type="delete" />删除</a-menu-item>-->
          <a-menu-item @click="onBaijiaAll(1)" key="1">
             设为百佳
          </a-menu-item>
          <a-menu-item @click="onBaijiaAll(2)" key="2">
             取消百佳
          </a-menu-item> 
        </a-menu>
        <a-button style="margin-left: 8px">
          批量操作
          <a-icon type="down" />
        </a-button>
      </a-dropdown>
 
       
    </div>

    <s-table
        ref="table"
        size="default"
        :columns="userColumns"
        :data="loadData"
        :alert="{ show: true, clear: () => { this.selectedRowKeys = [] } }"
        :rowSelection="{ selectedRowKeys: selectedRowKeys, onChange: onSelectChange }"
    >

      <span slot="name1" slot-scope="text,record">
          <div>
            {{ record.name }}
          <a-tag color="red" v-if="record.is_baijia==1">百佳四好运动员</a-tag>
            <br/>
            <span style="color: #999">{{ record.danwei }}</span>
            <br/>
            {{ record.num }}
            <br/>
            学段:{{ record.xueduan }}
          </div>
      </span>
      <span slot="huankao1" slot-scope="text,record">
          <r-switch  :formData="record" field="huankao" @change="setHuankao(record)" :checkedValue="1" :unCheckedValue="2" checkedChildren="缓考" unCheckedChildren="否" />
      </span>
      <span slot="danwei" slot-scope="text,record">
          <div style="margin-left: 10px; float: left">
            {{ record.user_name }}
            <br/>
            上传时间 {{ record.create_time|timeFormat }}
            <br/>
            注册时间 {{ record.today|timeFormat }}
          </div>
      </span>
      <span slot="jindu" slot-scope="text,record">
        人数{{ record.membercount }}<br/>
        <a-tag v-if="record.status==1" color="red">等待审核</a-tag>
        <a-tag v-else-if="record.status==2" color="green">审核成功</a-tag>
        <a-tag v-else-if="record.status==3" color="purple">审核失败</a-tag>
        <a-tag v-else>未提交</a-tag>
        <br/>
        <a v-if="record.resultszip && record.resultszip2">成绩已上传</a>
      </span>
      <span slot="action" slot-scope="text,record">
        <template>
          <a @click="handleEdit(record)">编辑</a>
          <a-divider type="vertical"/>
          <a-popconfirm title="删除后不可恢复,确定删除吗?" @confirm="deleteHandle(record)" okText="确定" cancelText="取消">
            <a href="javascript:;">删除</a>
          </a-popconfirm>
          <a-divider type="vertical"/>
          <a  @click="download(record, 1)">下载证书</a>
        </template>
      </span>
    </s-table>


    <a-modal
        :maskClosable="false"
        title="人员操作"
        :width="1000"
        :bodyStyle="{maxHeight:'500px','overflowY':'scroll'}"
        v-model="userFormVisible"
        @ok="handleUserFormOk"
    >
      <a-spin :spinning="saveLoading">
        <a-form :form="form" >
          <a-row :gutter="48">
            <a-col :md="12" :sm="24">
              <a-form-item
                  :labelCol="labelCol"
                  :wrapperCol="wrapperCol"
                  label="姓名"
                  hasFeedback
              >
                <a-input  v-decorator="[
              'name',
              {rules: [{ required: true, message: '请输入姓名' }]}
            ]"
                          placeholder="请输入姓名"/>
              </a-form-item>
            </a-col>
            <a-col :md="12" :sm="24">
              <a-form-item
                  :labelCol="labelCol"
                  :wrapperCol="wrapperCol"
                  label="身份证"
                  hasFeedback
              >
                <a-input  v-decorator="[
              'num',
              {rules: [{ required: true, message: '请输入身份证' }]}
            ]"
                          placeholder="请输入身份证"/>
              </a-form-item>
            </a-col>


          </a-row>

          <a-row :gutter="48">
            <a-col :md="12" :sm="24">
              <a-form-item
                  :labelCol="labelCol"
                  :wrapperCol="wrapperCol"
                  label="民族"
                  hasFeedback
              >
                <a-input  v-decorator="[
              'mingzu',
              {rules: []}
            ]"
                          placeholder="请输入民族"/>
              </a-form-item>
            </a-col>
            <a-col :md="12" :sm="24">
              <a-form-item
                  :labelCol="labelCol"
                  :wrapperCol="wrapperCol"
                  label="学段"
                  hasFeedback
              >
                <a-input  v-decorator="[
              'xueduan',
              {rules: []}
            ]"
                          placeholder="请输入学段"/>
              </a-form-item>
            </a-col>
            <a-col :md="12" :sm="24">
              <a-form-item
                  :labelCol="labelCol"
                  :wrapperCol="wrapperCol"
                  label="品德得分"
                  hasFeedback
              >
                <a-input  v-decorator="[
              'score_pingde',
              {rules: []}
            ]"
                          placeholder="请输入品德得分"/>
              </a-form-item>
            </a-col>
            <a-col :md="12" :sm="24">
              <a-form-item
                  :labelCol="labelCol"
                  :wrapperCol="wrapperCol"
                  label="学段得分"
                  hasFeedback
              >
                <a-input  v-decorator="[
              'score_xuexi',
              {rules: []}
            ]"
                          placeholder="请输入学段得分"/>
              </a-form-item>
            </a-col>
            <a-col :md="12" :sm="24">
              <a-form-item
                  :labelCol="labelCol"
                  :wrapperCol="wrapperCol"
                  label="气质得分"
                  hasFeedback
              >
                <a-input  v-decorator="[
              'score_qizhi',
              {rules: []}
            ]"
                          placeholder="请输入气质得分"/>
              </a-form-item>
            </a-col>
            <a-col :md="12" :sm="24">
              <a-form-item
                  :labelCol="labelCol"
                  :wrapperCol="wrapperCol"
                  label="技术得分"
                  hasFeedback
              >
                <a-input  v-decorator="[
              'score_jishu',
              {rules: []}
            ]"
                          placeholder="请输入技术得分"/>
              </a-form-item>
            </a-col>
            <a-col :md="12" :sm="24">
              <a-form-item
                  :labelCol="labelCol"
                  :wrapperCol="wrapperCol"
                  label="投票得分"
                  hasFeedback
              >
                <a-input  v-decorator="[
              'score_toupiao',
              {rules: []}
            ]"
                          placeholder="请输入投票得分"/>
              </a-form-item>
            </a-col>
          </a-row>


          <a-row :gutter="48">
            <a-col :md="12" :sm="24">
              <a-form-item
                  label="赛区"
                  :labelCol="labelCol"
                  :wrapperCol="wrapperCol"
              >
              {{userFormData.getaddress}}
 

              </a-form-item>
            </a-col> 
          </a-row>


        </a-form>

      </a-spin>
      <template slot="footer">
        <a-button key="cancel" @click="userFormVisible=false">取消</a-button>
        <a-button key="forward" :loading="saveLoading" type="primary" @click="handleUserFormOk">保存</a-button>
      </template>
    </a-modal>
  </a-card>
</template>

<script>
import STable from '@/components/table/'
import ATextarea from 'ant-design-vue/es/input/TextArea'
import AInput from 'ant-design-vue/es/input/Input'
import EditableCell from '@/components/EditableCell/'
import PicUploader from '@/components/PicUploader/'
import FileUploader from '@/components/FileUploader/'
import KaoguanPicker from '@/components/KaoguanPicker/'
import JianduPicker from '@/components/JianduPicker/'
import RSwitch from '@/components/RSwitch/'
import areaOptions from '@/utils/area'
import moment from 'moment'
import qs from 'qs'
import 'moment/locale/zh-cn';

import { 
  sjsqOptions, 
} from '@/api/sai'

moment.locale('zh-cn');

import {getApplyMemberList, memberDetail, memberDelete, memberEdit,setBaijiaAll} from '@/api/sihao'
import setting from "@/config/setting";

export default {
  name: 'SihaoMemberList',
  components: {
    AInput,
    ATextarea,
    FileUploader,
    PicUploader,
    STable,
    EditableCell,
    KaoguanPicker,
    JianduPicker,
    RSwitch
  },
  data() {
    return {
      areaOptions,
      userFormVisible: false,
      kaoguanPickerShow: false,
      jianduPickerShow: false,
      userVisible: false,
      visible: false,
      sjsqOptions: [],
      saveLoading: false,
      formData: {
        id: 0,
        danwei: '',
        datetitle_moment: null,
        datetitle: '',
        resultszip: [],
        kaoguan: [],
        jiandu: [],
        namekeys: [],
        areas: [],
      },
      time_range_moment: [],
      time_range: [],
      labelCol: {
//          xs: { span: 24 },
//          sm: { span: 5 },
        xs: {span: 24},
        sm: {span: 8},
      },
      wrapperCol: {
        xs: {span: 24},
        sm: {span: 12},
      },
      form: this.$form.createForm(this),
      form2: this.$form.createForm(this),
      mdl: {},

      // 高级搜索 展开/关闭
      advanced: false,
      // 查询参数
      queryParam: {
        keywords: '',
      },
      // 表头
      columns: [
        {
          title: '#',
          dataIndex: 'id',
          width: '50px'
        },
        {
          title: '单位信息',
          dataIndex: 'danwei',
          scopedSlots: {customRender: 'danwei'},
        },
        {
          title: '状态',
          dataIndex: 'jindu',
          scopedSlots: {customRender: 'jindu'},
        },
        {
          title: '操作',
          dataIndex: 'action',
          fixed: 'right',
          width: 200,
          scopedSlots: {customRender: 'action'},
        }
      ],


      //领取人员表头
      userColumns: [
        {
          title: '#',
          dataIndex: 'id',
          width: '100px'
        },
        {
          title: '人员信息',
          dataIndex: 'name',
          width: '150px',
          scopedSlots: {
            customRender: 'name1',
          }
        },
        // {
        //   title: '身份证',
        //   dataIndex: 'num'
        // },
        // {
        //   title: '等级',
        //   width: '100px',
        //   dataIndex: 'grade',
        // },
        // {
        //   title: '价格',
        //   width: '100px',
        //   dataIndex: 'price',
        // },
        // {
        //   title: '缓考',
        //   width: '100px',
        //   scopedSlots: {
        //     customRender: 'huankao1',
        //   }
        // },
        {
          title: '创建时间',
          width: '150px',
          dataIndex: 'create_time',
          customRender: (text) => {
            return moment(text * 1000).format('YYYY-MM-DD HH:mm:ss');
          }
        },
        {
          title: '操作',
          dataIndex: 'action',
          width: '200px',
          scopedSlots: {
            customRender: 'action',
          }
        },
      ],
      userPagination: {},
      userQuery: {
        manageid: 0,
        status: 0,
        page: 1,
        keywords: undefined
      },
      userFormData: {
        id: 0,
        pic: []
      },
      kaojiUserList: [],


      // 加载数据方法 必须为 Promise 对象
      loadData: parameter => {
        console.log('loadData');
        console.log(this.queryParam);
        let that = this;

        if (this.time_range_moment[0] && this.time_range_moment[1]) {
          this.queryParam.time_range = [
            this.time_range_moment[0].format('YYYY-MM-DD HH:mm:ss'),
            this.time_range_moment[1].format('YYYY-MM-DD HH:mm:ss')
          ]
        } else {
          this.queryParam.time_range = []
        }

        this.queryParam = Object.assign(this.queryParam, parameter);
        return getApplyMemberList(this.queryParam)
            .then(res => {
              console.log('res');
              return res.data
            })
      },

      selectedRowKeys: [],
      selectedRows: [],
      cashFormData: {
        ids: [],
        to_type: '',
        price: 0,
        note: '',
        count: 0,
      }
    }
  },
  computed: {},
  created() {
  },

  mounted() {
    let that = this;
      that.getSjsqOptions();
  },
  methods: {
    moment,
      getSjsqOptions() {
        let that = this;
        sjsqOptions({}).then(res => {
          that.sjsqOptions = res.data;
        });
      },
    handleCancel() {
      this.visible = false
    },
    //展开关闭
    toggleAdvanced() {
      this.advanced = !this.advanced
    },
    handleEdit(record) {
      let self = this
      this.userFormVisible = true
      memberDetail({id: record.id}).then(res => {
        setTimeout(() => {
          res.data.regist_date_moment = moment(res.data.regist_date*1000);
          self.form.setFieldsValue({...res.data})
          self.userFormData.id = record.id;
          self.userFormData = {...res.data};
        }, 200)
      })
      // console.log(this.mdl)
    },
    // 查
    onSearch() {
      let self = this;
      self.$refs.table.refresh(false)
    },
    deleteHandle(record) {
      let self = this
      memberDelete({id: record.id}).then(res => {
        self.$refs.table.refresh(false)
      })
    },
    // 增改 处理
    handleUserFormOk(e) {
      let self = this;
      e.preventDefault()
      this.form.validateFields((err, values) => {
        if (!err) {
          console.log('Received values of form: ', values)
          console.log('Received valuess of formData: ', self.userFormData)
          self.saveLoading = true;
          memberEdit({
            id:self.userFormData.id,
            name:values.name,
            num:values.num,
            mingzu:values.mingzu,
            xueduan:values.xueduan,
            score_pingde:values.score_pingde,
            score_xuexi:values.score_xuexi,
            score_qizhi:values.score_qizhi,
            score_jishu:values.score_jishu,
            score_toupiao:values.score_toupiao,
          }).then(res => {
            self.$message.success('修改成功')
            self.$refs.table.refresh(false)
            self.userFormVisible = false;
            self.saveLoading = false;
          }).catch(err =>{
            self.$message.error(err.data.msg);
            self.saveLoading = false;
          })

        }
      })
    },

    handleUserFormCancel() {
      this.userFormVisible = false
    },

    userSearch(selectedKeys, confirm) {
      let self = this
      confirm();
      self.fetchUserList();
    },
    userSearchReset(selectedKeys, confirm) {
      let self = this;
      confirm();
      self.userQuery.keywords = undefined;
      self.fetchUserList();
    },
    handleUserTableChange(pagination, filters, sorter) {
      console.log('filters', filters);
      let that = this;
      if (filters.grade) {
        that.userQuery.grade = filters.grade[0];
      } else {
        that.userQuery.grade = '';
      }
      const pager = {...this.pagination};
      pager.current = pagination.current;
      that.pagination = pager;
      that.userQuery.page = pagination.current;
      that.fetchUserList();
    },
    onBaijiaAll(status){
      let self = this;
      setBaijiaAll({ ids: this.selectedRowKeys ,'status':status })
        .then((res) => {
          self.$message.success("设置成功");
          self.$refs.table.refresh(false);
        })
        .catch((err) => {
          self.$message.error(err.data.msg);
        });
    },


    onSelectChange(selectedRowKeys, selectedRows) {
      this.selectedRowKeys = selectedRowKeys
      this.selectedRows = selectedRows
    },

    download(record, type) {
      switch (type) {
        case 1:
          window.open(setting.apiBaseURL + '/adminapi/csihao/memberDownload?id=' + record.id);
          break;
        case 2 :
          window.open(setting.apiBaseURL + '/adminapi/kaojiexame/downloadCert?id=' + record.qcxj_exame_id);
          break;
      }
    },
      sjsqFilter(inputValue, path) {
      return path.some(option => option.label.toLowerCase().indexOf(inputValue.toLowerCase()) > -1);
    },

    download2( type) {
      switch (type) {
        case 1:
          window.open(setting.apiBaseURL + '/adminapi/csihao/memberListDownload?' + qs.stringify(this.queryParam));
          break; 
      }
    }

  },
  filters: {},
  watch: {}
}
</script>


<style scoped>
.custom-filter-dropdown {
  padding: 8px;
  border-radius: 4px;
  background: #fff;
  box-shadow: 0 2px 8px rgba(0, 0, 0, .15);
}

.highlight {
  background-color: rgb(255, 192, 105);
  padding: 0px;
}
</style>
